import React from "react";
import './style.scss';


export default (props) => {

  // 用于微信小程序：专享价礼遇说明 
  // 小程序通过webview展示说明信息

  return (
    <div className="wrapper">
      <div className="mb-30">1. 多间房预订时，消费抵扣额度不可合并使用。若需共同使用，需将消费分别挂账至对应房间的消费金额中。</div>
      <div className="mb-30">2. 消费抵扣额度的使用范围以酒店前台告知为准。部分酒店可能按固定汇率将抵扣额度转换为当地货币，通常不与其他优惠折扣同享，且不可抵扣税费与服务费。</div>
      <div className="mb-30">3. 连续入住期间或同住人交替预订，仅可享受一次专享礼遇。</div>
      <div className="mb-30">4. 房型升级需依据实时房态安排，遵循 "同等级别内升级" 原则（普通房→普通房、行政房→行政房、套房→套房），部分房型不参与升级。一般仅可升级一个等级，酒店有权根据入住时房态决定是否升级，最终以酒店实际安排为准。</div>
      <div className="mb-30">5. 提前入住或延迟退房，需在入住前或离店前与酒店确认具体时间，最终安排以酒店回复为准。</div>
      <div className="mb-30">6. 若专享礼遇与酒店集团会员礼遇存在重复项目，将自动享受更优条款，具体以入住时酒店安排为准；若酒店促销信息条款与此冲突，以前台展示的促销政策为准。</div>
      <div className="fs-12 c-66 mb-30" style={{ fontWeight: 'bold' }}>重要提示</div>
      <div className="fs-12 c-66">本规则为通用说明，不代表当前专享价格包含上述所有礼遇，具体专享内容请以外部展示页面及促销说明为准。</div>
    </div>
  );
}